import './OnboardingPages.scss';

import React, {useEffect, useState} from 'react';
import {Alert, Button, Col, Container, Row, Spinner} from "react-bootstrap";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import Form from "react-bootstrap/Form";
import {Formik} from "formik";
import {useLocation, useNavigate} from "react-router-dom";
import * as yup from "yup";
import {SessionService} from "../../../services/api/SessionService";
import {CredentialsService} from "../../../services/api/CredientialsService";
import {LOGIN} from "../../../services/PageUtils";
import ErrorText from "../../../components/ErrorText";

interface Props {

}

const Register = ({}: Props) => {

    const navigate = useNavigate();
    const location: any = useLocation();

    const { confirmEmail } = CredentialsService()
    const { createSession } = SessionService()

    const [errMsg, setErrMsg] = useState<string>();
    const [loading, setLoading] = useState(false);

    const schema = yup.object().shape({
        code: yup.string().required("Code is required"),
    });

    useEffect(() => {
        setLoading(false);
    }, []);

    const submitForm = async (values: any) => {
        setLoading(true);
        setErrMsg(undefined);

        let confirmEmailResp = await confirmEmail({
            email: location.state.email,
            password: location.state.password,
        }, values.code)

        if (confirmEmailResp.error) {
            if (confirmEmailResp.error.apiError?.code === 'E1000') {
                setLoading(false);
                navigate(LOGIN);
                return;
            }

            setErrMsg(confirmEmailResp.error.message);
            setLoading(false);
            return;
        }

        let sessionResp = await createSession({
            email: location.state.email,
            password: location.state.password,
        })

        if (sessionResp.error) {
            setLoading(false);
            navigate(LOGIN);
            return;
        }

        setLoading(false);
    };

    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Container>
                <div className={"onboarding_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div>
                    <span className={"heading"}>Confirm Your Email</span>
                </div>

                <Formik
                    validationSchema={schema}
                    onSubmit={submitForm}
                    initialValues={{
                        code: "",
                    }}
                >
                    {({
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          values,
                          touched,
                          isValid,
                          errors,
                      }) => (
                        <Form
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Row>
                                <Col>
                                    <Form.Label column={'lg'} className={"onboarding_labelWithExplanation"}>
                                        Code
                                    </Form.Label>
                                    <span className={"onboarding_explanation"}>
                                        We have sent you a code to the email you used to register, please enter that code here.
                                    </span>
                                    <Form.Group controlId="detailsForm.Code" style={{ marginTop: '0.25em' }}>
                                        <Form.Control
                                            required
                                            className="onboarding_input"
                                            type="text"
                                            name="code"
                                            placeholder="xxxx"
                                            value={values.code}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                        />
                                        {touched.code &&
                                            errors.code && (
                                                <Alert
                                                    variant={"danger"}
                                                >
                                                    {errors.code}
                                                </Alert>
                                            )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {errMsg && <ErrorText>{errMsg}</ErrorText>}

                            {!loading &&
                                <Button type="submit" disabled={loading} className={"forgotEmailConfirm_submitBtn"}>
                                    CONFIRM EMAIL
                                </Button>}
                            {loading &&
                                <Button disabled={loading} onClick={() => {}} className={"forgotEmailConfirm_submitBtn"}>
                                    <Spinner animation={"border"}/>
                                </Button>}
                        </Form>
                    )}
                </Formik>
            </Container>
        </div>
    )
}

export default Register;